import {
  createSlugElement,
  createTypeTag,
  createStatusTag,
  createActionButtons,
} from "./constants";

export const transformKeywordsToRowData = (keywords, onEdit, onDelete) => {
  return keywords.map((keyword) => ({
    id: keyword.id,
    name: keyword.name,
    slug: createSlugElement(keyword.slug),
    type: createTypeTag(keyword.type),
    status: createStatusTag(keyword.deleted),
    actions: createActionButtons(keyword, onEdit, onDelete),
  }));
};
